<template>
    <div>
        <v-app>
            <v-card :loading="loading" elevation="2" outlined class="p-3">
                <v-card-title class="justify-content-between">
                    <div>
                    </div>
                    <v-autocomplete label="نوع سفارش"
                                    @change="changeAccess($event)"
                                    :items="access"
                                    item-text="name"
                                    item-value="value"
                                    dense
                                    outlined
                    >
                    </v-autocomplete>
                    <div class="mb-7">
                        <v-btn class="btn-search"
                               @click="tableProps = tablePropsDefault; getSites()">
                            <v-icon>mdi-refresh</v-icon>
                            بارگذاری مجدد
                        </v-btn>
                    </div>

                </v-card-title>
                <div class="row">
                    <div class="col-md-12 p-5">
                        <template>
                            <v-row justify="center">
                                <custom-popup v-model="showDialog"
                                              max-width="900"
                                              hide-overlay
                                              :cons="cons"
                                              transition="dialog-bottom-transition"
                                              hide-confirm>
                                    <v-card>

                                        <informations v-if="showDialog" :modal="()=>{this.showDialog=false}"
                                                      :reqAgain="()=>{this.reloadTable(url)}" :id="myID"></informations>
                                    </v-card>
                                </custom-popup>
                            </v-row>
                        </template>
                        <template>
                            <v-row justify="center">
                                <custom-popup v-model="showPlus"
                                              max-width="900"
                                              hide-overlay
                                              :cons="cons"
                                              transition="dialog-bottom-transition"
                                              hide-confirm>
                                    <v-card>
                                        <add-new v-if="showPlus" :transactionsCount="transactionsCount"
                                                 :modal="()=>{this.showPlus=false}"
                                                 :reqAgain="()=>{this.reloadTable(url)}" :id="myID"></add-new>
                                    </v-card>
                                </custom-popup>
                            </v-row>
                        </template>
                        <template>
                            <v-row justify="center">
                                <custom-popup v-model="myDia"
                                              max-width="900"
                                              hide-overlay
                                              :cons="cons"
                                              transition="dialog-bottom-transition"
                                              hide-confirm>
                                    <v-card>
                                        <pay-page v-if="myDia" :addPeyment="addPeyment" :transactionCount="transactionsCount"
                                                  :admin="true" :modal="()=>{this.myDia=false}"
                                                  :reqAgain="()=>{this.reloadTable(url)}" :archives="infos"></pay-page>
                                    </v-card>
                                </custom-popup>
                            </v-row>
                        </template>
                        <terminal-table class="col-12" :currentPage="userInfo.meta.current_page"
                                        :perPage="userInfo.meta.per_page" v-if="isMobile" :getData="getSites"
                                        :pageCount="userInfo.meta.last_page"
                                        :options="tableProps" :datas="userInfo" :headers="columns"></terminal-table>
                        <data-table v-else :data="userInfo" :columns="columns"
                                    :translate="translate"
                                    :per-page="[10, 25, 50, 100]"
                                    @on-table-props-changed="reloadTable">
                            <div slot="filters" slot-scope="{ tableFilters, perPage }">
                                <div class="row mb-2">
                                    <div class="col-md-3">
                                        <select class="form-control pr-3"
                                                v-model="tableFilters.length">
                                            <option :key="page" v-for="page in perPage">
                                                {{ page }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                    </div>
                                    <div class="col-md-3">
                                    </div>

                                    <div class="col-md-3">
                                        <v-text-field outlined dense label="جست و جو"
                                                      class="pl-3"
                                                      @change="(i) => (tableFilters.search = i)">
                                        </v-text-field>
                                    </div>
                                </div>
                            </div>

                        </data-table>
                    </div>
                </div>
            </v-card>
        </v-app>
    </div>
</template>

<script>
import actionButton from '@/view/content/button'
import Informations from "./informations";
import PayPage from "../site/payPage";
import button from "@/view/content/button";
import AddNew from "./addNew";
import CustomPopup from "../../../core/plugins/TitleRibbon/plugins/popup/customPopup";

export default {
    name: "requestsList",
    components: {CustomPopup, AddNew, PayPage, Informations},
    data() {
        return {
            dialogPayment: false,
            myDia: false,
            myID: '',
            addPeyment: '',
            transactionsCount: '',
            paymentId: '',
            showDialog: false,
            cons: {title: 'اطلاعات درخواست'},
            showPlus: false,
            payDialogInfo: {},
            payableTransaction: null,
            selectedRows: [],
            access: [
                {name: 'سئو', value: 'admin/form/seo'},
                {name: 'طراحی سایت', value: 'admin/form/design'},
                {name: 'پشتیبانی سایت', value: 'admin/form/support'},
            ],
            paymentLoading: false,
            errors: [],
            loading: false,
            errorMsg: '',
            userWallet: [],
            dialogInfo: null,
            tab: null,
            translate: {
                nextButton: 'بعدی',
                previousButton: 'قبلی',
                rowsPerPageText: 'تعداد در صفحه',
                noDataText: 'داده ای برای نمایش وجود ندارد',
                placeholderSearch: 'جستجو',
            },
            url: 'admin/form/site',
            userInfo: {},
            tableProps: {
                search: '',
                length: 10,
                page: 1,
                column: 'id',
                dir: 'desc',
            },
            tablePropsDefault: {
                search: '',
                length: 10,
                column: 'id',
                dir: 'desc',
                page: 1
            },
            columns: [
                {
                    label: 'ردیف',
                    isCheckBox: true,
                    transform: (val) => {
                        let row = this.userInfo.current_page - 1;
                        row = row * this.userInfo.per_page;
                        return row + val.row + 1;
                    },
                },
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    colStyle: 'width: 100px;'
                },
                {
                    label: 'عنوان',
                    name: 'name',
                    orderable: true,

                },
                {
                    label: 'نام ونام خانوادگی کاربر',
                    name: 'user.name',
                    transform(val) {
                        return val.data.user.name + ' ' + val.data.user.lastName
                    },
                    orderable: true,

                },
                {
                    label: 'نوع سفارش',
                    name: 'type',
                    transform: (value) => {
                        const translate =
                            {
                                design: 'طراحی سایت',
                                seo: 'سئوی سایت',
                                support: 'پشتیبانی سایت',
                            };

                        return translate[value.data.type];
                    },
                    orderable: true,
                },
                {
                    label: 'نوع سایت',
                    name: 'site_type',
                    orderable: true,
                    transform: (value) => {
                        const persian = {
                            'personal': 'شخصی',
                            'corporative': 'شرکتی',
                            'shop': 'فروشکاهی',
                            'charity': 'موسسه خیریه',
                            'news': 'خبری',
                            'download': 'دانلود',
                        };

                        return persian[value.data.site_type];
                    }
                },
                {
                    name: 'status',
                    primary: true,
                    label: 'وضعیت',
                    transform: (value) => {
                        return this.getStatusBadge(value.data.status)
                    }
                },

                {
                    label: 'مدیریت',
                    name: 'actions',
                    component: button,
                    handler: this.actions,
                    event: 'action',
                    permission_prefix: 'user_',
                    meta: {
                        buttons: [
                            {
                                name: "show",
                                label: "مشاهده اطلاعات",
                                icon: "eye",
                                class: 'btn-outline-warning',
                                type: 'show',
                                action: this.actions,
                                permission: "user_access"
                            },
                            {
                                name: "Pay",
                                label: "پرداخت اقساط",
                                icon: "dollar-sign",
                                type: 'show',
                                class: 'btn-outline-info',
                                action: this.actions,
                                condition: this.buttonsCondition
                            },
                        ]
                    }
                },
            ],
            statusBadge: '',
            infos: {},
            userValid: true,
            isRejected: false,
            isPending: false,
            userInfoGot: false
        }
    },
    created() {
        this.getSites('admin/form/site')
    },
    mounted() {
        this.getSites('admin/form/site');
    },
    methods: {
        changeAccess(URL) {
            this.getSites(URL)
        },
        buttonsCondition(status) {
            return [
                "pending",
                "reject"
            ].indexOf(status) <= -1;
        },
        Pay(data) {
            this.infos = data.payments;
            this.transactionsCount = data.payments.transactions.length
            this.addPeyment = data.payments.transactions[0].payment_id
            this.myDia = true;
        },
        paymentDialog(data) {
            this.payDialogInfo = data
            this.dialogPayment = true
        },
        getUserInfo() {
            this.userInfoGot = true;
            this.$modal.showLoading();
            this.requestApiGet('userInfo')
                .then(res => {
                    this.$modal.hideLoading();
                    let response = res.data.data
                    console.log(response.status)
                    if (response.status == 'accept') {
                        this.userValid = true
                        this.statusBadge = 'accept'
                    } else if (response.status == 'reject') {
                        this.isRejected = true
                        this.userValid = false
                        this.statusBadge = 'reject'
                        let _this = this;
                        this.$modal.error('اطلاعات تکمیلی نیاز به ویرایش دارد', 'اطلاعات شما دارای مشکل میباشد',
                            undefined,
                            {},
                            [
                                {
                                    text: "رفتن به صفحه تکمیل اطلاعات",
                                    onClick() {
                                        _this.$router.push({path: "/company-register"});
                                    }
                                }
                            ]
                        )
                    } else if (response.status == 'pending') {
                        this.isPending = true
                        this.userValid = false
                        this.statusBadge = 'pending'
                        this.$modal.warning('در انتظار تایید اطلاعات',
                            'در مرحله در انتظار تایید توسط پشتیبانی شما قادر به ثبت بیلبورد نمیباشید.')
                    } else {
                        this.userValid = false
                        this.statusBadge = ''
                        let _this = this;
                        this.$modal.info('اطلاعات خود را تکمیل کنید',
                            'تا زمانی که اطلاعات خود را تکمیل نکنید قادر به ثبت بیلبورد نمیباشید.',

                            undefined,
                            {},
                            [
                                {
                                    text: "تکمیل اطلاعات",
                                    onClick() {
                                        _this.$router.push({path: "/company-register"});
                                    }
                                }
                            ]
                        )
                    }
                })
                .catch(res => {
                    this.$modal.hideLoading();
                })
        },
        getStatusBadge(status) {
            let text = status;
            let color = 'light'

            switch (status) {
                case "pending":
                    text = 'در انتظار تایید';
                    color = 'warning'
                    break;


                case "accept":
                    text = 'منتظر پرداخت';
                    color = 'info'
                    break

                case "reject":
                    text = 'رد شده';
                    color = 'danger'
                    break

                case "disable":
                    text = 'مسدود';
                    color = 'light'
                    break
            }

            return `<span class="badge badge-${color}">${text}</span>`;
        },
        selectAll(c) {
            window.Vue.$emit("selectedAllCheckbox", c);
        },
        change(data, checked) {
            if (checked) {
                this.selectedRows.push(data.id);
            } else {
                let index = this.selectedRows.indexOf(data.id)
                this.selectedRows = [
                    ...this.selectedRows.slice(0, index),
                    ...this.selectedRows.slice(index + 1, this.selectedRows.length)
                ]

            }
            window.document.querySelector("#select_all").checked = this.selectedRows.length == this.userInfo.data.length

        },
        getSites(url = this.url, params = this.tableProps) {
            this.loading = true;
            this.requestApiGet(url, params).then(response => {
                this.userInfo = response.data;
            }).finally(() => {
                this.loading = false;
                if (!this.userInfoGot) {
                    // this.getUserInfo();
                }
            })
        },
        reloadTable(params) {
            this.getSites(this.url, params)
        },
        actions(data, type) {
            this[type](data)
        },
        show(data) {
            this.myID = data.id
            this.showDialog = true;
        },

    },
    computed: {
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getSites(this.url);
                    return true
                case 'sm':
                    this.getSites(this.url);
                    return true
                case 'md':
                    this.getSites(this.url);
                    return false
                case 'lg':
                    this.getSites(this.url);
                    return false
                case 'xl':
                    this.getSites(this.url);
                    return false
            }
        },
    },
}
</script>

<style scoped>

</style>